export default __webpack_public_path__ + "static/media/fork-right.9a514abb.svg";